export default "__VITE_ASSET__KMajwzHK__"